import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import Sidebar, { COLLAPSED_WIDTH } from './Sidebar';
import Navbar from './Navbar';
import PageSuspenseFallback from '../PageSuspenseFallback';
import ChatPanel from '../ai/ChatPanel';
import AiNotifications from '../ai/AiNotifications';
import RocketRefresh from '../motion/RocketRefresh';
import { requestRefresh } from '../../store/cloudSlice';

const DRAWER_WIDTH = 240;
const COLLAPSE_KEY = 'cloudSidebarCollapsed';
const EASE = '280ms cubic-bezier(.2,.8,.2,1)';

const readCollapsed = () => {
  try { return localStorage.getItem(COLLAPSE_KEY) === '1'; } catch (_) { return false; }
};
const saveCollapsed = (value) => {
  try { localStorage.setItem(COLLAPSE_KEY, value ? '1' : '0'); } catch (_) {}
};

export default function Layout() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(readCollapsed);
  const token = useSelector((s) => s.auth.token);
  const width = collapsed ? COLLAPSED_WIDTH : DRAWER_WIDTH;

  const toggleCollapsed = () => {
    saveCollapsed(!collapsed);
    setCollapsed(!collapsed);
  };
  const dispatch = useDispatch();
  const refresh = React.useCallback(() => dispatch(requestRefresh()), [dispatch]);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar
        drawerWidth={DRAWER_WIDTH}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
      />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          ml: { md: `${width}px` },
          width: { md: `calc(100% - ${width}px)` },
          transition: `margin-left ${EASE}, width ${EASE}`
        }}
      >
        <Navbar onMenuClick={() => setMobileOpen(true)} drawerWidth={width} onRefresh={refresh} />
        <RocketRefresh onRefresh={refresh} sx={{ flexGrow: 1, p: { xs: 2, md: 3 }, minWidth: 0, overflow: 'auto' }}>
          <Box component="main" sx={{ minWidth: 0 }}>
            {/* Keyed by token (here and on the AI panels below) so an org switch remounts them and refetches for the new tenant */}
            <React.Suspense key={token} fallback={<PageSuspenseFallback />}>
              <Outlet />
            </React.Suspense>
          </Box>
        </RocketRefresh>
      </Box>
      <React.Fragment key={token}>
        <ChatPanel />
        <AiNotifications />
      </React.Fragment>
    </Box>
  );
}
